import React, { memo, useEffect, useState } from 'react';
import { Autocomplete, Button, Paper, Text, Box, Flex, Group } from '@mantine/core'
import classes from './ManageRawmaterial.module.css';
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";
import { baseUrl } from '../../../Constants/constant'
import { useNavigate } from 'react-router-dom';
import RawMaterialDataTable from './RawMaterialDataTable';
import InputButton from '../../../CustomComponent/InputFileButton/Inputbutton.component';
import SampleFile from '../../../CustomComponent/DownloadSampleFile/Samplefile.component';

const ManageRawMaterial = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500); // Debounce input for better performance

    return () => clearTimeout(timeout); // Cleanup on re-renders
  }, [search]);

  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
          <Flex
            style={{ justifyContent: 'space-between' }}
            align="center"
          >
            <Box>
              <Text ta="left">Raw Material</Text>
            </Box>
            <Group>
              <Autocomplete
                // label="Your favorite library"
                value={search}
                onChange={handlechange}
                placeholder="Search by Raw-material"
                leftSection={<IoMdSearch />}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/manage-raw-material/addrawmaterial')}
              >
                Add Raw Material
              </Button>
              <InputButton
                url={`${baseUrl}admin/raw-materials/import-file`}
              />
              <SampleFile type={'raw-material'} />
            </Group>
          </Flex>
          <RawMaterialDataTable editLink={'/manage-raw-material/addrawmaterial'} search={sendsearch} />
        </Box>
      </Paper>
    </>
  )
}

export default memo(ManageRawMaterial)
